<template>
	<div class="cotent_cco">
		<div class="content_top">
			<img :src="category.dingimg" alt="" class="w100">
			<!-- <h3>{{category.cat_name}}</h3> -->
		</div>
		<div class="content_center1">
			<div class="container">
				<h3>{{category.cat_name}}</h3>
				<!-- <h4>Hisan offers a range of premium quality weld overlay clad wear plates.</h4> -->
				<p>{{category.description}}
                </p>
			</div>
			
		</div>
		<div class="tips3">
			
			<div class="container">
				<h3>Ассортимент продукций</h3>
				<ul class="tips3List">
					<li v-for="(item,index) in tips3List" :key="index"  @click="golink(item.id)">
						<img :src="item.image" alt="" class="tisp3_img"/>
						<div class="text_bottom">
							<div class="tips3_text">
								<h4>{{item.title}}</h4>
								<p>{{item.overview}}</p>
							</div>
							<div class="buttom">
								<img src="@/assets/images/index/jt_r.png" alt="" />
								<span>Читать далее</span>
							</div>
						</div>
					</li>
				</ul>	
			</div>
			
		</div>
		<div class="list_box4">
			<div class="container">
		        <h3>Характеристики</h3>
				<ul>
					<li>
						Равномерное распределение первичного карбида хрома в большом количестве.
					</li>
					<li>
						Плоская поверхность с отличной плоскостностью пластины.
					</li>
					<li>Твердость: 57-63HRC.</li>
					<li>Доступно несколько сортов для различных применений.</li>
					<li>Отличные характеристики износа (ASTM G65, процедура A).</li>
					<li>Увеличенный размер листа для повышения коэффициента использования плиты.</li>
					<li>Равномерная толщина с допуском.</li>
					<li>Хорошая формуемость благодаря равномерному снятию напряжения в накладке.</li>
				</ul>
			</div>
		</div>
		
        <div class="pro_box">
			<div class="container">
				<h3>Сотрудничество с компанией Hisan по биметаллическим плитам</h3>
				<p>Опорная стальная пластина обеспечивает пластинам Hisan структурную целостность, благодаря чему наши накладные пластины изготавливаются без повреждения сварочной накладки, независимо от формы и сложности конструкции. Компания Hisan имеет возможность изготавливать детали износа по размерам, изготовление включает в себя резку, формовку, сварку, крепление шпильками, сборку, шлифовку или другие виды обработки изделия.</p>
				<!-- <ul>
					<li v-for="(item,index) in proList" :key="index" >
						<div class="text_bottom">
							<div class="pro_text">
								<h4>{{item.name}}</h4>
								<p>{{item.text}}</p>
							</div>
						</div>
						<img :src="item.imgsrc" alt="" @click="imgYu(item.imgsrc1)" class="w100"/>
						
					</li>
				</ul> -->
				<h3>Применение продукции</h3>
				<div class="swiper-container">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide" v-for="(item,index) in lbList" :key="index">
				           <img class="w100" :src="item.show_img" alt="">
							
				        </div>
						
				    </div>
				    <div class="swiper-pagination1"></div>
					
				</div>
			</div>
		</div>
		<div class="yzbox" @click="hideYu()">
			<img src="" alt="" id='yz'>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import axios from 'axios';
	export default {
		data() {
			return {
				lbList:[
					
				    
				],
                category: {cat_id: "", cat_name: "",description:''},
                
				tips3List:[
					{
						imgsrc:require('@/assets/images/cco/HS100.png'),
						name:'HS100',
						text:'HS100 is a chromium carbide composite cladding fusion bonded to a mild steel backing material.\nVery high volume of chromium carbides fuse to base plate and evenly distributed throughout the uniform thickness of the deposit, creating a bimetallic material with high...',
					},
					{
						imgsrc:require('@/assets/images/cco/HS200.png'),
						name:'HS200',
						text:'HS200, produced by our patented welding technique, is chromium carbide composite cladding fusion bonded to a mild steel backing material.\nVery high volume of chromium carbides fuse to base plate and evenly distributed throughout the uniform...',
					},
				    {
						imgsrc:require('@/assets/images/cco/HS300.png'),
						name:'HS300',
						text:'HS300 is chromium carbide and Niobium carbide composite cladding fusion bonded to a mild steel backing material.\nVery high volume of complex carbides fuse to base plate and evenly distributed throughout the uniform thickness of the deposit, creating a bimetallic material...',
					},
				    {
						imgsrc:require('@/assets/images/cco/HS600.png'),
						name:'HS600',
						text:'HS600 is complex carbides composite cladding fusion bonded to a mild steel backing material.\nVery high volume of complex carbides fuse to base plate and evenly distributed throughout the uniform thickness of the deposit, creating a bimetallic material...',
					},
				    {
						imgsrc:require('@/assets/images/cco/HS-F.png'),
						name:'HS-F',
						text:'HS-F is manufactured using advanced fusion bond welding technology to apply chromium carbides on to a mild steel substrate producing consistent chemistry and microstructure with smooth overlay deposit.',
					},
				    {
						imgsrc:require('@/assets/images/cco/HS-X.png'),
						name:'HS-X',
						text:'HS-X is customized complex carbides composite cladding fusion bonded to a mild steel backing material.\nVery high volume of complex carbides fuse to base plate and evenly distributed throughout the uniform...',
					},
				    
				    
				],
				proList:[
					{
						imgsrc:require('@/assets/images/cco/img_1.png'),
						imgsrc1:require('@/assets/images/cco/img_11.png'),
						name:'Cutting',
						text:'Hisan overlay plates could be cut only by plasma, waterjet and laser cutting. Plasma cutting is the recommended method to cut our plates.',
					},
					{
						imgsrc:require('@/assets/images/cco/img_2.png'),
						imgsrc1:require('@/assets/images/cco/img_21.png'),
						name:'Bores',
						text:'Liner plate with straight bores can be plug welded to base plates;  Liner plate with CSK holes can fit well with bolt studs(M12,M16, M20 etc).',
					},
					{
						imgsrc:require('@/assets/images/cco/img_3.png'),
						imgsrc1:require('@/assets/images/cco/img_31.png'),
						name:'Stud attachment',
						text:'Our plate can be fabricated with studs welded to backing of wear plate.',
					},
					{
						imgsrc:require('@/assets/images/cco/img_4.png'),
						imgsrc1:require('@/assets/images/cco/img_41.png'),
						name:'Cold bending',
						text:'Our plates can be cold bended, forming is suggested be perpendicular to the welding bead direction.',
					},
				]
			}
			
		},
		methods:{
			golink(id){
				const routeUrl = this.$router.resolve({
					path: "/detail",
					query: { id: id },
				});	
				window.open(routeUrl.href, "_self");
			},
			imgYu(src){
				$(".yzbox img").attr("src",src)
				$(".yzbox").show();
				
			},
			hideYu(src){
				$(".yzbox").hide();
				
				$(".yzbox img").attr("src",'')
				
			},
		},
		mounted(){
			var that = this;
			axios({
				method: 'post',
				url:`${this.$apiYf}/anlistapi.php`,
				data: {
					catid:1
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.tips3List = res.data.productc_list;
			});
            axios({
				method: 'post',
				url:`${this.$apiYf}/anlicategoryapi.php`,
				data: {
					cid:1
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.category = res.data.category;
			});
            axios({
				method: 'post',
				url:`${this.$apiYf}/indexlunboapi.php`,
				data: {
					cid:11
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.lbList = res.data.lunboinfo;
                that.$nextTick(() => {
                    that.kvSwiper = new Swiper ('.swiper-container', {
                        loop: true, 
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            el: '.swiper-pagination1',
                            clickable: true,
                        },
                        navigation: {
                            nextEl: '.swiper-button-next1',
                            prevEl: '.swiper-button-prev1',
                            clickable: true,
                        },
                        centeredSlides: true,
                        slidesPerView: 3,
                        spaceBetween: 30,
                        speed: 500,
                        roundLengths : true, 
                        observer:true,
                        observeParents:true,
                        observeSlideChildren:true,
                        calculateHeight: true,
                        on:{
                            
                            slideChangeTransitionEnd: function(){ 
                                
                            }  
                          },
                    });
                })
			});
			
		}
	
	}
</script>

<style lang="scss">
    .cotent_cco{
        .content_center1{
        	width:100%;padding-bottom:7vw;
            background:url('../../assets/images/cco/cco_bg.jpg') no-repeat center;background-attachment: fixed;background-size: cover;
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	h4{
        		font-size: 20px;color:#fff;margin-bottom: 1vw;
        	}
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        }
        .list_box4{background: #0c4fa2;padding: 0vw 0 4vw;
            h3{font-size: 48px;color: #fff;margin: 4vw 0 2.5vw;text-align: left;
                position: relative;line-height: 1.8;
                &::after{
                    content: '';
                    border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
                }
            }
        	ul{display: flex;flex-wrap: wrap;
        		li{width: 50%;font-size: 20px;color: #fff;padding-left: 18px;position: relative;margin-bottom: 1vw;
        			&::after{content: "";width: 8px;height: 8px;border: solid 2px #fff;border-radius: 50%;display: block;position: absolute;left:0;top:14px;margin-top: -4px;}
        		}
        	}
        }
        
        .tips3{
        	background: #e4f0fa;padding: 5vw 0;
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;
        		color: #0c4fa2;position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	.tips3List{
        		display: flex;flex-wrap: wrap;
        		li{width: 30%;margin-bottom: 60px;margin-right: 5%;
        			&:nth-child(3n){
        				margin-right: 0;
        			}
        			.tisp3_img{background: #fff;}
        			.text_bottom{background: #fff;padding: 28px;height: 290px;position: relative;
        				.tips3_text{
        					h4{font-size: 24px;color: #000;margin-bottom: 16px;}
        					p{font-size: 14px;color: #666;white-space: pre-wrap;
        					overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 7;-webkit-box-orient: vertical;
        					line-height: 20px;}
        					@media (max-width: 1440px) {
        					    h4{font-size: 20px;}
        						p{font-size: 13px;color: #666;line-height: 20px;}
        						
        					}
        					
        				}
        				.buttom{
        					position: absolute;left: 28px;bottom: 28px;display: flex;cursor: pointer;
        					span{line-height: 26px;color: #0c4fa2;border: solid 2px #0c4fa2;display: inline-block;
        						padding: 0 14px;margin-left: 4px;
        					}
        					&:hover{
        						span{background: #0c4fa2;color: #fff;}
        					}
        				}
        			}
        		}
        	}
        }
        .pro_box{
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        	ul{
        		display: flex;justify-content: space-between;flex-wrap: wrap;
        		li{
        			width:49%;padding: 2%;border: solid 1px #858585;margin-bottom: 2.5vw;
        			.pro_text{
        				font-size: 24px;color: #0c4fa2;margin-bottom: 20px;font-weight: bold;
        					p{font-size: 14px;line-height: 1.5;margin-top: 20px;}
        				}
        			
        			&:hover{
        				img{transform:scale(1.1,1.1);transition: all .9s ease;}
        			}	
        		}
        	}
        	.swiper-container{margin-bottom: 5vw;}
        	.swiper-pagination1{text-align: center;margin: 1vw 0;
        		.swiper-pagination-bullet{opacity: 0.5;margin: 0 10px;}
        		.swiper-pagination-bullet-active{color: #0c4fa2;opacity: 1;}
        	}	
        	.swiper-button-prev1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aal.png) no-repeat center 100%;
        		position: absolute;left: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aal1.png) no-repeat center 100%;
        		}
        	}
        	.swiper-button-next1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aar.png) no-repeat center 100%;
        		position: absolute;right: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aar1.png) no-repeat center 100%;
        		}
        	}
        }
        .yzbox{width:100%;height:100vh;position: fixed;left:0;top:0;z-index:999;
        background:rgba(0,0,0,0.7);display: none;
        	img{width:80%;position: absolute;left:0;top:0;bottom:0;right:0;display: block;margin:auto;}
        }
    }
	
</style>